const COMMON_PASSWORDS = [
  "12345678","123456789","1234567890","password","password1","qwerty123",
  "abc12345","iloveyou","monkey123","dragon12","master12","letmein1",
  "baseball","football","shadow12","michael1","jennifer","trustno1",
  "sunshine","princess","welcome1","charlie1","donald12","password123",
  "admin123","root1234","toor1234","pass1234","test1234","guest123",
  "changeme","default1","temp1234","qwerty12","asdf1234","zxcv1234",
  "1q2w3e4r","q1w2e3r4","asd123456","123qweasd","1234qwer","12345qwe",
  "abcd1234","aaaa1111","1111aaaa","pass@123","P@ssw0rd","Welcome1",
  "Passw0rd","Admin123","User1234","Login123","Access12","Secure12",
];

export function validatePassword(password) {
  const errors = [];
  if (password.length < 8) errors.push("Minimo 8 caracteres");
  if (!/[A-Z]/.test(password)) errors.push("Al menos 1 mayuscula");
  if (!/[a-z]/.test(password)) errors.push("Al menos 1 minuscula");
  if (!/[0-9]/.test(password)) errors.push("Al menos 1 numero");
  if (!/[^A-Za-z0-9]/.test(password)) errors.push("Al menos 1 simbolo (@#$!...)");
  if (COMMON_PASSWORDS.includes(password.toLowerCase())) errors.push("Contrasena demasiado comun");
  return errors;
}

export function getPasswordStrength(password) {
  if (!password) return { level: 0, label: "", color: "#475569" };
  const errs = validatePassword(password);
  if (errs.length >= 4) return { level: 1, label: "Muy debil", color: "#dc2626" };
  if (errs.length >= 2) return { level: 2, label: "Debil", color: "#ea580c" };
  if (errs.length === 1) return { level: 3, label: "Media", color: "#ca8a04" };
  if (password.length >= 12) return { level: 5, label: "Muy fuerte", color: "#16a34a" };
  return { level: 4, label: "Fuerte", color: "#22c55e" };
}
